<template>
    <admin-layout>
        <template #header>
            <div class="grid items-center justify-center grid-cols-2">
                <div>
                    <h1 class="text-xl font-semibold leading-tight text-white">Clienti</h1>
                </div>
                <div class="flex items-center justify-center sm:justify-end">
                    <a href="/exportstudents" class="inline-block p-2 text-sm border border-white rounded-lg cursor-pointer hover:bg-green-600"><img src="/img/icons/excel.svg" class="inline-block w-10 pr-4">download</a>
                </div>
            </div>
        </template>

        <div class="py-12">
            <div class="mx-auto max-w-7xl sm:px-6 lg:px-8">
                <div id="student-table" class="overflow-hidden bg-white shadow-xl sm:rounded-lg">
                    <TableStudents :students="students" />
                </div>
            </div>
        </div>
    </admin-layout>
</template>

<script>
    import AdminLayout from '@/Layouts/AdminLayout'
    import TableStudents from '@/Components/TableStudents'

    export default {
        props: ["students"],
        components: {
            AdminLayout,
            TableStudents,
        },
    }
</script>